<template>
  <div class="main-wrapper">
    <p class="necessary-bold">
      <span
        :class="
          validKinds() && validAnotherKind() ? 'valid-field' : 'unvalid-field'
        "
        >➤</span
      >
      Виды договоров (контрактов), расчеты по которым будут осуществляться через
      Банк:
    </p>
    <div class="checkboxes">
      <label v-for="kind in agreementKinds" :key="kind.ID">
        <input
          type="checkbox"
          v-model="kind.CHECKED"
          @click="kind.VALUE == 'Иное' ? (otherKind = '') : otherKind"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('AGREEMENTS_KINDS') != -1
          "
        />
        {{ kind.VALUE }}
      </label>
    </div>
    <input
      type="text"
      v-model="otherKind"
      v-if="idOfOther != -1 && agreementKinds[idOfOther].CHECKED"
      :onchanged="
        otherKind != null && otherKind.length > 255
          ? (otherKind = otherKind.substr(0, 255))
          : otherKind
      "
      :disabled="
        pageInfo.DISABLED != null &&
          pageInfo.DISABLED.indexOf('AGREEMENTS_KINDS') != -1
      "
    />
    <div class="tax-modes">
      <p class="necessary-bold">
        <span :class="!validTaxMode() ? 'unvalid-field' : 'valid-field'"
          >➤</span
        >
        Режим налогообложения:
      </p>
      <div class="main-checkboxes" v-for="item in checkboxes" :key="item.ID">
        <label>
          <input
            type="checkbox"
            v-model="item.CHECKED"
            @click="onCheck(item.ID)"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('TAX_MODE_FULL') != -1
            "
          />
          {{ item.VALUE }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgreementKinds",
  props: {
    pageInfo: {},
    pageName: String,
  },
  data: () => ({
    sendData: {},
    agreementKinds: [],
    idOfOther: -1,
    checkboxes: [],
    selectedId: -1,
    otherKind: "",
  }),
  methods: {
    onCheck(id) {
      this.checkboxes.forEach((element) => {
        if (element.ID != id) element.CHECKED = false;
      });
      this.selectedId = id;
    },
    validTaxMode() {
      let a = false;
      this.checkboxes.forEach((element) => {
        if (element.CHECKED) a = true;
      });
      return a;
    },
    validKinds() {
      var a = false;
      this.agreementKinds.forEach((item) => {
        if (item.CHECKED) a = true;
      });
      return a;
    },
    validAnotherKind() {
      return (
        !this.agreementKinds[this.idOfOther].CHECKED ||
        (this.agreementKinds[this.idOfOther].CHECKED &&
          this.otherKind.length > 0)
      );
    },
    createSendData() {
      this.sendData.AGREEMENTS_KINDS = [];
      this.sendData.TAX_MODE_FULL = this.selectedId;
      this.sendData.ANOTHER_AGREEMENT_KING = this.otherKind;
      this.agreementKinds.forEach((item) => {
        if (item.CHECKED) this.sendData.AGREEMENTS_KINDS.push(item.ID);
      });
    },
    validation() {
      var msg = "";
      if (!this.validKinds())
        msg += "Выберите хотя бы один вид договора (контракта)<br>";
      if (!this.validAnotherKind()) msg += "Заполните поле 'Иное'<br>";
      if (!this.validTaxMode()) msg += "Выберите режим налогообложения";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.createSendData();
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
  },
  async created() {
    try {
      this.otherKind = this.pageInfo.ANOTHER_AGREEMENT_KING;
      this.sendData.INN = this.pageInfo.INN;

      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      this.sendData.ID = this.pageInfo.ID;
      this.agreementKinds = this.pageInfo.AGREEMENTS_KINDS;
      this.checkboxes = this.pageInfo.TAX_MODE_FULL;
      this.checkboxes.forEach((item) => {
        if (item.CHECKED) this.selectedId = item.ID;
      });
      this.idOfOther = this.agreementKinds.length - 1;
      this.validation();
    } catch (error) {
      console.log(error);
    }
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
.necessary {
  color: red;
}

label {
  margin-bottom: 5px;
}
input[type="text"] {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 50%;
  position: relative;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
</style>
